/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/graph_decrease'
export default icon
